<template>
  <div>
    <div class="pa-10">
      <v-container>
        <v-row justify-lg="space-around">
          <v-col lg="3" md="4" sm="8" cols="12" v-for="(item,index) in nodeList" :key="index" class="pt-5 pa-2">
            <v-card elevation="10">
              <v-card-title class="card-title-class">
                <v-container>
                  <v-row>
                    <v-col cols="4">
                      <div class="title-card-offset pa-2">

                        <v-avatar
                            elevation="5"
                            :color="item.color"
                            size="100"
                        >
                          <span class="white--text text-h5">{{ item.name }}</span>
                        </v-avatar>
                      </div>
                    </v-col>
                    <v-col cols="8">
                      <div class="text-center">
                        {{ item.name }}
                      </div>
                      <div class="text-subtitle-1 grey--text text-center">
                        Copy and Skip
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <div class="text-center">
                        <v-btn v-clipboard:success="onCopy" v-clipboard:copy="`${url}/subscription/info/${item.id}`"
                               text>
                          复制
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="text-center">
                        <v-btn @click="skip(item)"
                               text>
                          跳转
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-snackbar
          v-model="snackbar"
          :timeout="message.timeout"
      >
        {{ message.text }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            关闭
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import {basUrl} from "@/api/env";
import {list} from "@/api/resources/subscription"
import {mapMutations} from "vuex";


export default {
  data: () => ({
    snackbar: false,
    message: {
      text: '复制成功!',
      timeout: 3000,
    },
    nodeList: [],
    url: undefined
  }),
  mounted() {
    this.url = basUrl
    this.init();
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init() {
      this.setLoading();
      list().then((req) => {
        this.nodeList = req.data.data
      }).finally(() => {
        this.clearLoading()
      })
    },
    onCopy() {
      this.snackbar = true;
    },
    skip({id}) {
      window.open(`${this.url}/subscription/info/${id}`, '_blank')
    }
  },

}
</script>

<style scoped>
.title-card-offset {
  top: -50px;
  left: 10px;
  position: relative;
}

.card-title-class {
  height: 100px
}
</style>
